var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinterscreencoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 105,
    viewBox: "0 0 364 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.05 78.49H147.8V41.37H73.57V78.49H92.5",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24 63.53H92.12V100.65H129.24V63.53Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 76.31H101.14",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.36 29.76H87.77",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4 29.76H100.8",
    stroke: "#F77284",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43 29.76H113.84",
    stroke: "#FFD600",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47 29.76H126.88",
    stroke: "#141413",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 88.5H101.14",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.05 20.11H183.81V57.23H258.05V20.11Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61 76.54V57.46",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.24 76.54V57.46",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74 78.49H240.12",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86 46.22L201.95 37.11L210.48 46.52L220.11 40.83L228.86 44.11L249.15 32.53C249.15 32.53 257.01 39.03 258.04 40.06",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1 4.25H293.98V78.49H331.1V4.25Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.98 53.6L318.73 78.49H306.36L305.11 53.6H319.98Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32 53.6L358.07 78.49H345.7L344.45 53.6H359.32Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 21.87H294.09",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54 46.38V38.79",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54 36.38V28.78",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.34 30.79C346.96 30.79 344.22 28.05 344.22 24.67C344.22 21.29 346.96 18.55 350.34 18.55",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.34 30.79C353.72 30.79 356.46 33.53 356.46 36.91C356.46 40.29 353.72 43.03 350.34 43.03",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.31 25.06V57.68",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63 41.37H0",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363.79,
    height: 104.89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterscreencoffee);
export default __webpack_public_path__ + "static/media/printerscreencoffee.8c84ec801b1d1a9a78bef5fe85060a28.svg";
export { ForwardRef as ReactComponent };